// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -1548158497
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { UserTask } from './models/task/usertask';
import { User } from './models/security/user';
import { UserLookupItem } from './models/security/userlookupitem';

export interface getUserTasks_Filter {
  noOlderThanDays: number;
  includeCompleted: boolean;
  createdDate: string;
  followUpDate: string;
  completedDate: string;
  resolutionChannelId: number;
  participantTypeId: number;
  note: string;
  taskTypeId: number;
  procedureItemId: number;
  memberName: string;
  taskPriorityId: number;
  userId: string;
}

export interface getFilteredUsers_Filter {
  groupId: string;
  teamId: string;
  permission: string;
  scope: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class UsersApiService {
  constructor(protected http: HttpClient) {}

  getUserTasks(
    userGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getUserTasks_Filter>
  ): Observable<SmartListResult<UserTask>> {
    let url = environment.chiliSauceApiRoot + `/api/Users/${userGuid}/tasks`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<UserTask>>(url, { params: params });
  }

  getFilteredUsers(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getFilteredUsers_Filter>
  ): Observable<SmartListResult<User>> {
    let url = environment.chiliSauceApiRoot + `/api/Users/filtered`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<User>>(url, { params: params });
  }

  getAllUsers(criteria?: SmartListCriteria): Observable<SmartListResult<User>> {
    let url = environment.chiliSauceApiRoot + `/api/Users`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<User>>(url);
  }

  addUser(newUser: User): Observable<User> {
    const url = environment.chiliSauceApiRoot + `/api/Users`;
    return this.http.post<User>(url, newUser);
  }

  getAllUsersArray(): Observable<User[]> {
    const url = environment.chiliSauceApiRoot + `/api/Users/usersArray`;
    return this.http.get<User[]>(url);
  }

  getUserLookup(): Observable<UserLookupItem[]> {
    const url = environment.chiliSauceApiRoot + `/api/Users/lookup`;
    return this.http.get<UserLookupItem[]>(url);
  }

  getUserById(userGuid: string): Observable<User> {
    const url = environment.chiliSauceApiRoot + `/api/Users/${userGuid}`;
    return this.http.get<User>(url);
  }

  updateUser(user: User, userGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Users/${userGuid}`;
    return this.http.put<any>(url, user);
  }

  deleteUser(userGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Users/${userGuid}`;
    return this.http.delete(url);
  }

  getUserGroupsByUserId(userGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Users/${userGuid}/groups`;
    return this.http.get<any>(url);
  }

  getUserPermissionsByUserId(userGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Users/${userGuid}/permissions`;
    return this.http.get<any>(url);
  }
}
